export * from "./DescriptionText";
